import axios from 'axios';

export default axios.create({
    baseURL: "https://cyberistanbul.com:5033/",
    headers: {
        'Content-Type': 'application/json',
    }
});
